import * as yup from "yup";

import { dobValidationSchemaFactory } from "../../../utils/yupSchemaUtils";
import { STATES } from "../../../constants/states";

export const A5_DETAILS_INITIAL_VALUES = {
  address: {
    city: "",
    state: "",
    street: "",
    zip_code: "",
  },
  dob: "",
  email: "",
  first_name: "",
  gender: "",
  last_name: "",
  mobile: "",
  notification_type: "",
  pcp_id: "",
};

export const A5_DETAILS_SCHEMA = [
  {
    elementConfig: {
      label: "First Name",
      placeholder: "First name",
      type: "text",
    },
    elementType: "input",
    name: "first_name",
  },
  {
    elementConfig: {
      label: "Last Name",
      placeholder: "Last name",
      type: "text",
    },
    elementType: "input",
    name: "last_name",
  },
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "dob",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  {
    displayName: "Address",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      options: STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
  {
    elementConfig: {
      label: "Practice",
      options: [],
      placeholder: "Practice",
    },
    elementType: "select",
    name: "pcp_practice_id",
  },
  {
    elementConfig: {
      label: "Primary Care Provider",
      options: [],
      placeholder: "Primary Care Provider",
    },
    elementType: "select",
    name: "pcp_id",
  },
  {
    elementConfig: {
      label: "Notification Type",
      options: [
        { display: "Text", value: "text" },
        { display: "Email", value: "email" },
      ],
      placeholder: "Notification Type",
    },
    elementType: "select",
    name: "notification_type",
  },
];

export const A5_DETAILS_VALIDATION = yup.object().shape({
  address: yup.object().shape({
    city: yup
      .string()
      .matches(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/, "Enter a valid City")
      .nullable(),
    state: yup.string().nullable(),
    street: yup.string().nullable(),
    zip_code: yup
      .string()
      .matches(/^\d{5}(?:[-\s]\d{4})?$/, "Enter a valid zip code")
      .nullable(),
  }),
  dob: dobValidationSchemaFactory("MMDDYYYY").required("Required"),
  email: yup.string().email("Enter a valid email address").required("Email is required"),
  first_name: yup
    .string()
    .required("First Name is required")
    .matches(/^[a-zA-Z-]+$/, "Digits, space & special characters are not allowed"),
  gender: yup.string().required("Gender is required"),
  last_name: yup
    .string()
    .required("Last Name is required")
    .matches(/^[a-zA-Z-]+$/, "Digits, space & special characters are not allowed"),
  mobile: yup
    .string()
    .matches(/^\d{10}$/, "Contact Number must be a valid US number")
    .required("Mobile no. is required"),
  notification_type: yup.string().required("Notification Type is required"),
  pcp_id: yup.string().required("Primary Care Provider is required"),
});
